// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__31wUm","box":"WorkspacesBox_box__3OuR5","node":"WorkspacesBox_node__3Y1PT"};